import { css } from '@emotion/react';
import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';

export const placeHolderTextStyle = css`
  color: ${colors.white};
  text-align: center;
  ${ZeeFontRegular(14, 20)};
`;

export const winningPrizeImageStyle = css`
  width: 100%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 20px;
`;
